import { Navigate, Outlet } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useAuth } from '@/lib/auth';
import { beginLogin, isHiveMode } from '@/lib/hive';
import { useBootstrap } from '@/lib/hooks/useBootstrap';

export function RequireAuth() {
  const { session, loading } = useAuth();
  const bootstrap = useBootstrap();

  // Hive mode: unauthenticated users go straight to Hive sign-in (full
  // redirect), preserving the deep link they were after.
  const redirectToHive = isHiveMode() && !loading && !session;
  useEffect(() => {
    if (redirectToHive) {
      void beginLogin(window.location.pathname + window.location.search);
    }
  }, [redirectToHive]);

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-slate-500">
        Loading…
      </div>
    );
  }
  if (!session) {
    if (isHiveMode()) {
      return (
        <div className="flex h-full items-center justify-center text-sm text-slate-500">
          Redirecting to sign-in…
        </div>
      );
    }
    return <Navigate to="/login" />;
  }
  if (bootstrap.isPending && !bootstrap.data) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-slate-500">
        Setting up your workspace…
      </div>
    );
  }
  if (bootstrap.isError) {
    return (
      <div className="mx-auto max-w-md p-10 text-sm text-[var(--color-critical)]">
        <p className="font-semibold">Couldn't set up your workspace.</p>
        <p className="mt-2 text-slate-600 dark:text-slate-400">
          {(bootstrap.error as Error).message}. Please refresh — if the problem persists, email
          shashank@momentumai.dev.
        </p>
      </div>
    );
  }
  return <Outlet />;
}
